import React , {useState, useEffect,  Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Badge, Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table } from 'react-bootstrap'

import Meta from '../Meta'

import Moment from 'react-moment';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import CodeView from '../utils/CodeView'

import DHeader from '../pieces/DHeader';
import DText from '../pieces/DText';
import DCode from '../pieces/DCode';

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

export const QuickStart = ({}) => {

    const dispatch = useDispatch()


    const [newModel, setNewModel] = useState("") 

    const [data, setData] = useState([])




    useEffect(() => {
       

    }, [])




    return (

        <>
        <Meta title={'Laeyerz - QuickStart'} description={'Building a simple functional workflow with Laeyerz'} keywords={'Laeyerz, AI, LLM, RAG, Agents, QuickStart, Workflows, langchain like'}/>
       
    
        
        <DHeader>Quick Start</DHeader>


        <DText>Creating a workflow that takes in a user query, and then passes it into flows. </DText>

        <DHeader className='h5'>function 1</DHeader>

        <DCode> 
        {`def model0(input0:str)->(str):
    print("Model 0 :", input0)
    output = input0+"_model0"
    return output
            `}
        </DCode>




<Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>

<p className='h5'>function 2</p>

<CodeView text_in=
    {`
def model1(input1:str)->(str):
    print("Model 1 :", input1)
    output = input1 + "_model1"
    return output
`}/>

</Card>



<Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>

<p className='h5'>function 3</p>

<CodeView text_in=
{`
def model2(input2:str)->(str):
    print("Model 2 :", input2)
    output = input2 + "_model2"
    return output
`} />


</Card>

<hr />


<Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>


<p className='h5'>Creating Nodes.</p>

<CodeView text_in=
{`
node1 = Node("Model0")
node1.inputs  = {"Inputs:input0":"input0"}
node1.outputs = {"output0":"Model0:output0"}
node1.set_function(model0)
`}
/>

<CodeView text_in=
{`
node2 = Node("Model1")
node2.inputs  = {"Model0:output0":"input1"}
node2.outputs = {"output1":"Model1:output1"}
node2.set_function(model1)
`}
/>


<CodeView text_in=
{`
node3 = Node("Model2")
node3.inputs  = {"Model1:output1":"input2"}
node3.outputs = {"output2":"Outputs:output2"}
node3.set_function(model2)
`}
/>



<p className='h5'>Creating the Workflow</p>

<CodeView text_in=
{`
simple_flow = Flow("Flow 1")
simple_flow.state.update("Inputs", "input0", "Hello")
`}
/>


<p className='h5'>Add the Nodes to the Workflow</p>

<CodeView text_in=
{`
simple_flow.add_node(node1)
simple_flow.add_node(node2)
simple_flow.add_node(node3)
`}
/>


<p className='h5'>Add the Edges to the Workflow</p>

<CodeView text_in=
{`
simple_flow.add_edge("START", "Model0")
simple_flow.add_edge("Model0", "Model1")
simple_flow.add_edge("Model1", "Model2")
simple_flow.add_edge("Model2", "END")
`}
/>

</Card>


<Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>
<p className='h5'>Adding Edges.</p>

<CodeView text_in=
{`
rag_flow.add_edge("START", "Embedding_Model")
rag_flow.add_edge("Embedding_Model", "Vector_DB")

#rag_flow.add_edge("Vector_DB", "Prompt")
#rag_flow.add_edge("Prompt", "LLM")

rag_flow.add_edge("Vector_DB", "LLM")
rag_flow.add_edge("LLM", "END")
`}
/>

</Card>


<Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>


<p className='h5'>Finalize the Flow.</p>

<CodeView text_in=
{`
simple_flow.finalize()
`}
/>


</Card>


<Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>


<p className='h5'>Chat Query.</p>

<CodeView text_in=
{`
#run the flow
input_data = {
    "input0": "Hello, world!"
}
output = simple_flow.run(input_data)     
`}
/>

</Card>


       

                
       
        
        </>

       

   
    )
}


export default QuickStart
